module.exports = "/static/Images/en/Ten.png";